// 'use client'
// import { useState, useEffect } from 'react'
// import { Switch } from '@headlessui/react'
// import { useRouter } from 'next/navigation'
// import { updateSearchParams, removeSearchParam, getSearchParams } from "@utils";



// function PetFriendlyFilter({ title, dictionary }) {
//     const router = useRouter();

//     const [petfriendly, setPetFriendly] = useState(false)

//     const handleUpdateParams = (e) => {
//         console.log(e)
//         let newPathName
//         if (e == true) {
//             newPathName = updateSearchParams(title, e);
//         } else {
//             newPathName = removeSearchParam(title);
//         }

//         router.push(newPathName);
//         router.refresh()
//     };

//     useEffect(() => {
//         const petfriendlyValue = getSearchParams('petfriendly')

//         if (petfriendlyValue == 'true') {
//             setPetFriendly(true)
//         } else {
//             setPetFriendly(false)
//         }
//     }, [handleUpdateParams])

//     return (
//         <div className='w-full flex flex-row items-center justify-between mt-2 px-1'>
//             <span className='text-sm text-secondary'>{dictionary.onlyIncludePetfriendly}</span>
//             <Switch
//                 checked={petfriendly}
//                 // onChange={setPetFriendly}
//                 onChange={(value) => {
//                     setPetFriendly(value)
//                     handleUpdateParams(value)
//                 }}
//                 className={`${petfriendly ? 'bg-maincolor' : 'bg-forth'
//                     } relative inline-flex h-6 w-11 items-center rounded-full border-[1px] border-forth shadow-sm`}
//             >
//                 <span className="sr-only">Only Include Pet Friendly</span>
//                 <span
//                     className={`${petfriendly ? 'translate-x-6' : 'translate-x-1'
//                         } inline-block h-4 w-4 transform rounded-full bg-white transition`}
//                 />
//             </Switch>
//         </div>
//     )
// }

// export default PetFriendlyFilter

'use client'
import { useState, useEffect } from 'react'
import { Switch } from '@headlessui/react'
import { useRouter, useSearchParams } from 'next/navigation'
import { updateSearchParams, removeSearchParam } from "@utils";

function PetFriendlyFilter({ title, dictionary }) {
  const router = useRouter();
  const searchParams = useSearchParams();

  // Initialize the state directly from the URL on component mount
  const initialPetFriendly = searchParams.get('petfriendly') === 'true';
  const [petfriendly, setPetFriendly] = useState(initialPetFriendly);

  const handleToggle = (value) => {
    // 1. Update the local state instantly for a quick UI response
    setPetFriendly(value);

    // 2. Build the new URL without refreshing
    let newPathName;
    if (value) {
      newPathName = updateSearchParams(title, 'true'); // Use 'true' string for URL
    } else {
      newPathName = removeSearchParam(title);
    }
    
    // 3. Update the URL without forcing a reload.
    // Use router.replace() to avoid cluttering browser history.
    router.replace(newPathName);
  };

  // The useEffect is now unnecessary as we initialize state from the URL

  return (
    <div className='w-full flex flex-row items-center justify-between mt-2 px-1'>
      <span className='text-sm text-secondary'>{dictionary.onlyIncludePetfriendly}</span>
      <Switch
        checked={petfriendly}
        onChange={handleToggle}
        className={`${petfriendly ? 'bg-maincolor' : 'bg-forth'
          } relative inline-flex h-6 w-11 items-center rounded-full border-[1px] border-forth shadow-sm`}
      >
        <span className="sr-only">Only Include Pet Friendly</span>
        <span
          className={`${petfriendly ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-white transition`}
        />
      </Switch>
    </div>
  );
}

export default PetFriendlyFilter;